import React from 'react';
import { IconClip } from './icons';

// opts: {t, go?, amb?} · t se ecoa como burbuja del usuario · amb → botón ámbar (desborde)
export const Opts = ({ opts, onChoose, visible }) => {
  if (!visible || !opts || !opts.length) return null;
  return (
    <div className="opts" data-testid="opts">
      {opts.map((o, i) => {
        const clip = /^📎\s*/.test(o.t);
        return (
          <button
            key={i}
            type="button"
            className={`opt ${o.amb ? 'amb' : i === 0 ? 'primary' : 'ghost'}`}
            onClick={() => onChoose(o)}
            data-testid={`opt-${i}`}
          >
            {clip ? <IconClip size={15} /> : null}
            {o.t.replace(/^📎\s*/, '')}
          </button>
        );
      })}
    </div>
  );
};
